export default __webpack_public_path__ + "static/media/logo.e2b7cd09.svg";